import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConstants } from 'src/app/app.constants';
import { FormService } from 'src/app/services/form.service';
import { ModalService } from 'src/app/services/modal.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { PreguntaService } from 'src/app/services/pregunta.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-preguntamodal',
  templateUrl: './preguntamodal.component.html',
  styleUrls: ['./preguntamodal.component.css']
})
export class PreguntamodalComponent implements OnInit {

  @Input() data;
  form: FormGroup;
  submitted: Boolean = false;
  comboOpcion1: any;
  comboOpcion2: any;
  combosList: any;
  usuario: any;

  constructor(private activeModal: NgbActiveModal, private formService: FormService, private modal: ModalService,
    private alert: NotificacionesService, private utils: UtilsService, private preguntaService: PreguntaService) {
    this.combosList = [];
    this.comboOpcion1 = this.utils.clonarLista(AppConstants.OPCIONES_PREGUNTAS);
    this.comboOpcion2 = this.utils.clonarLista(AppConstants.OPCIONES_PREGUNTAS);
    this.combosList.push(this.comboOpcion1);
    this.combosList.push(this.comboOpcion2);
  }

  ngOnInit(): void {
    this.usuario = this.utils.obtenerDatosUsuario().usuario;
    this.form = this.formService.getPreguntaModalForm(this.data, this.combosList, this.usuario);
  }

  accept() {
    this.submitted = true;
    if (this.form.invalid)
      return;
    this.modal.mostrarModalCargando();
    if (this.form.value.idPregunta > 0)
      this.update(this.form.value);
    else
      this.save(this.form.value);
  }

  save(pregunta) {
    let request = {
      idPregunta: pregunta.idPregunta,
      idVotacion: pregunta.idVotacion,
      pregunta: pregunta.pregunta,
      descripcion: pregunta.descripcion,
      opcionesMininas: Number(pregunta.opcionesMinimas.nombre),
      opcionesMaximas: Number(pregunta.opcionesMaximas.nombre),
      votoNulo: this.utils.getNumberFromBoolean(pregunta.votoNulo),
      usuario: pregunta.usuario
    };
    this.preguntaService.guardar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo guardar la pregunta, intente de nuevo', true);
    });
  }

  update(pregunta) {
    let request = {
      idPregunta: pregunta.idPregunta,
      idVotacion: pregunta.idVotacion,
      pregunta: pregunta.pregunta,
      descripcion: pregunta.descripcion,
      opcionesMininas: Number(pregunta.opcionesMinimas.nombre),
      opcionesMaximas: Number(pregunta.opcionesMaximas.nombre),
      votoNulo: this.utils.getNumberFromBoolean(pregunta.votoNulo),
      usuario: pregunta.usuario
    };
    this.preguntaService.actualizar(request).subscribe((data: any) => {
      this.modal.cerrarModalCargando();
      if (this.utils.validarObjeto(data) && data.codigo === AppConstants.RESPONSECODES.OK) {
        this.alert.success(data.mensaje, true);
        this.close();
      }
      else
        this.alert.error(data.mensaje, true);
    }, (error: any) => {
      console.error('Error', error);
      this.modal.cerrarModalCargando();
      this.alert.error('No se pudo actualizar la pregunta, intente de nuevo', true);
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close();
  }

}
